import Vue from 'vue';
import Vuex from 'vuex';
import actions from '@/store/actions';
import mutations from '@/store/mutations';
import {getFromStorage} from '@/helpers/storage';
import BuildingMeters from '@/data/models/building-meters';
import {AuthUser} from '@/data/models/auth-session';

Vue.use(Vuex);

export interface AppState {
  applicationStarted: boolean;
  currentUser: AuthUser | null;
  currentUserBuildings: BuildingMeters[];
  isLimited: boolean;
  isAdmin: boolean;
  breadcrumbName: string;
  breadcrumbBuilding: string;
  breadcrumbMeter: string;
  loading: boolean;
}

export default new Vuex.Store<AppState>({
  state: {
    applicationStarted: false,
    currentUser: null,
    currentUserBuildings: getFromStorage('currentUserBuildings', []),
    isLimited: true,
    isAdmin: false,
    breadcrumbName: '',
    breadcrumbBuilding: '',
    breadcrumbMeter: '',
    loading: false,
  },
  mutations,
  getters: {
    isApplicationStarted: state => state.applicationStarted,
    getUser: state => state.currentUser,
    currentUserBuildings: state => state.currentUserBuildings,
    isLoggedIn: state => state.currentUser !== null,
    isAdmin: state => state.isAdmin,
    isLimited: state => state.currentUser !== null && state.isLimited,
    breadcrumbName: state => state.breadcrumbName,
    breadcrumbBuilding: state => state.breadcrumbBuilding,
    breadcrumbMeter: state => state.breadcrumbMeter,
  },
  actions,
});
